import { Feature } from "../enums/Feature.enum";
import { RibbonColor } from "../enums/Ribbon.enum";
import { StoreFeature } from "../types/Configuration/Settings.type";
import { Ribbon } from "../types/Ribbon.type";


export const StoreFeaturesList: Map<Feature, StoreFeature> = new Map([
  [Feature.MTO_OCTO, {
    feature: Feature.MTO_OCTO,
    name: `feature.${Feature.MTO_OCTO}.name`,
    description: `feature.${Feature.MTO_OCTO}.description`,
    image: 'assets/images/mto.png'
  }],
  [Feature.RIBBON, {
    feature: Feature.RIBBON,
    name: `feature.${Feature.RIBBON}.name`,
    description: `feature.${Feature.RIBBON}.description`,
    image: 'assets/images/ribbon.png'
  }],
]);

export const RibbonStyles: Map<RibbonColor, Ribbon> = new Map([
  [RibbonColor.ORANGE, {
    type: RibbonColor.ORANGE,
    color: "#DE8929",
    images: {
      box: "assets/images/ribbons/BoxImages/RibbonBox-1.imageset/packagingLuce@3x.png",
      ribbon: "assets/images/ribbons/RibbonsImages/RibbonImage-1.imageset/ribbonLuce.png",
      scene: "assets/images/ribbons/StorytellingInspirations/Storytelling-RibbonInspiration-1.imageset/storytellingLuce@3x.png",
    }
  }],
  [RibbonColor.BEIGE, {
    type: RibbonColor.BEIGE,
    color: "#E9D7C6",
    images: {
      box: "assets/images/ribbons/BoxImages/RibbonBox-2.imageset/packagingTravertino@3x.png",
      ribbon: "assets/images/ribbons/RibbonsImages/RibbonImage-2.imageset/ribbonTravertino.png",
      scene: "assets/images/ribbons/StorytellingInspirations/Storytelling-RibbonInspiration-2.imageset/storytellingTravertino@3x.png",
    }
  }],
  [RibbonColor.BLUE, {
    type: RibbonColor.BLUE,
    color: "#223A5E",
    images: {
      box: "assets/images/ribbons/BoxImages/RibbonBox-3.imageset/packagingMediterraneo@3x.png",
      ribbon: "assets/images/ribbons/RibbonsImages/RibbonImage-3.imageset/ribbonMediterraneo.png",
      scene: "assets/images/ribbons/StorytellingInspirations/Storytelling-RibbonInspiration-3.imageset/storytellingMediterraneo@3x.png",
    }
  }],
  [RibbonColor.GREEN, {
    type: RibbonColor.GREEN,
    color: "#004E4C",
    images: {
      box: "assets/images/ribbons/BoxImages/RibbonBox-4.imageset/packagingLauro@3x.png",
      ribbon: "assets/images/ribbons/RibbonsImages/RibbonImage-4.imageset/ribbonLauro.png",
      scene: "assets/images/ribbons/StorytellingInspirations/Storytelling-RibbonInspiration-4.imageset/storytellingLauro@3x.png",
    }
  }],
  [RibbonColor.BROWN, {
    type: RibbonColor.BROWN,
    color: "#B5472B",
    images: {
      box: "assets/images/ribbons/BoxImages/RibbonBox-5.imageset/packagingTerracotta@3x.png",
      ribbon: "assets/images/ribbons/RibbonsImages/RibbonImage-5.imageset/ribbonTerracotta.png",
      scene: "assets/images/ribbons/StorytellingInspirations/Storytelling-RibbonInspiration-5.imageset/storytellingTerracotta@3x.png",
    }
  }],
  [RibbonColor.MAGENTA, {
    type: RibbonColor.MAGENTA,
    color: "#84195D",
    images: {
      box: "assets/images/ribbons/BoxImages/RibbonBox-6.imageset/packagingImpero@3x.png",
      ribbon: "assets/images/ribbons/RibbonsImages/RibbonImage-6.imageset/ribbonImpero.png",
      scene: "assets/images/ribbons/StorytellingInspirations/Storytelling-RibbonInspiration-6.imageset/storytellingImpero@3x.png",
    }
  }],
  [RibbonColor.GREY, {
    type: RibbonColor.GREY,
    color: "#C2C2C2",
    images: {
      box: "assets/images/ribbons/BoxImages/RibbonBox-7.imageset/packagingVulcano@3x.png",
      ribbon: "assets/images/ribbons/RibbonsImages/RibbonImage-7.imageset/ribbonVulcano.png",
      scene: "assets/images/ribbons/StorytellingInspirations/Storytelling-RibbonInspiration-7.imageset/storytellingVulcano@3x.png",
    }
  }],
])
